import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import * as searchPaths from '../../constants/search-paths';
import * as paginatedPageSizes from '../../constants/paginated-page-sizes';
import { createFetchResults } from '../../common/util/create-fetch-results';
import SearchResultsWrapper from '..//search/results/wrapper';
import PreviewCardDeletable from '../resources/preview-card-deletable';
import { SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING } from '../../constants/search';
import { hasActiveSearch } from '../../common/util/search-query-utils';

// Components
import NoResult from '../common/no-result';
import Loading from '../common/loading';

export default class AccountSharedObjects extends React.Component {
  static displayName = 'AccountSharedObjects'

  static propTypes = {
    session: PropTypes.object.isRequired,
    groups: PropTypes.object,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.oneOf([SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING]),
  }

  onCardRender (resource) {
    return (
      <PreviewCardDeletable
        accountSettings={this.props.account && this.props.account.settings}
        allowApprovedContent={this.props.session.allowApprovedContent}
        accountId={this.props.session.accountId}
        available
        resource={resource}
      />
    );
  }

  render () {
    const { groups, session, results } = this.props;
    const { isAdmin, account, publicOnly, isAccountCurator = false } = session;

    if (groups.listIsLoading) {
      return (
        <div className="AppHandler--loading">
          <Loading />
        </div>
      );
    }

    const baseParams = {};

    if (isAdmin || isAccountCurator) {
      baseParams.accountId = account.id;
      baseParams.showPublic = true;
    }

    const canShowPublic = (isAdmin || isAccountCurator) && !publicOnly;
    const hasResults = Boolean(results.total);
    const noResultsMessage = hasResults
      ? formatMessage('No Results Found')
      : formatMessage('No Resources To Manage');

    const resultsPerPage = paginatedPageSizes.MANAGED_RESOURCES_PAGE_SIZE;
    const fetchResults = createFetchResults(searchPaths.RESOURCES_MANAGED, resultsPerPage);

    const showSuggestions = hasResults && hasActiveSearch(this.props.router.query);

    return (
      <SearchResultsWrapper
        baseParams={baseParams}
        fetchResults={fetchResults}
        resultsPerPage={resultsPerPage}
        searchPrivateObjects={false}
        emptyMessage={
          <NoResult
            title={noResultsMessage}
            showSuggestions={showSuggestions}
            className="AccountResources-no-result"
          />
        }
        canShowPublic={canShowPublic}
        canToggleLayout={false}
        onCardRender={resource => this.onCardRender(resource)}
        {...this.props}
      />
    );
  }
}
